import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Util } from '../../../utils/util';
import { SharedService } from '../../shared.service';

@Component({
  selector: 'app-avaible-balance-info',
  templateUrl: './avaible-balance-info.component.html',
  styleUrls: ['./avaible-balance-info.component.styl'],
  encapsulation: ViewEncapsulation.None
})
export class AvaibleBalanceInfoComponent implements OnInit {
	@Input() inputValue: number;
	@Output() disableButton: EventEmitter<boolean> = new EventEmitter();

	saldoSaque: any;
	limiteDisponivel: any;

  constructor(private sharedService: SharedService) { }

  ngOnInit() {
		this.getBalance();
  }

	getBalance() {
		this.sharedService.getBalance().subscribe( (data: any) => {
			this.saldoSaque = data.Retorno.SaldoSaque;
			this.limiteDisponivel = data.Retorno.LimiteDisponivel;
		});
	}

	showInfoSaldo() {
		const showInfoSaldo = this.inputValue > this.saldoSaque;
		this.disableButton.emit(showInfoSaldo);

		return showInfoSaldo;
	}

	getLimitValue(): string {
		const value = this.inputValue;
		return Util.formatValue(value - this.saldoSaque);
	}

	getTextSaldo(): string {
		const value = this.inputValue

		if (value > this.saldoSaque) {
			if (value <= this.saldoSaque + this.limiteDisponivel) {
				return `Nesta operação você utilizará <b>${this.getLimitValue()}</b> do seu <b>Limite Omni Plus</b> e estará sujeito a cobrança de encargos proporcionais aos dias de uso do limite.`;
			} else {
				return `Você não possui saldo disponível para realizar este pagamento`;
			}
		}
	}



}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/components/avaible-balance-info/avaible-balance-info.component.ts